import React from 'react';
import {View, Text, StyleSheet, TouchableOpacity, Dimensions} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import {fontFamily} from '../../helpers/fontFamily';
import i18n from 'i18n-js';

const OnDemandCountdown = props => {
  const {message, seconds, onCancel} = props;
  const windowWidth = Dimensions.get('window').width;
  const isMobile = windowWidth < 900;

  return (
    <View style={styles.overlay} testID="onDemandCountdown">
      <LinearGradient
        locations={[0, 1]}
        colors={['#5c7c9c', '#2c4358']}
        style={[styles.card, {width: isMobile ? '90%' : 520}]}>
        <Text style={styles.message} testID="onDemandCountdownMessage">
          {message}
        </Text>

        <View style={styles.circle} testID="onDemandCountdownCircle">
          <Text style={styles.seconds} testID="onDemandCountdownSeconds">
            {seconds}
          </Text>
        </View>

        {onCancel && (
          <TouchableOpacity
            testID="onDemandCountdownCancel"
            onPress={onCancel}
            style={styles.cancelButton}>
            <Text style={styles.cancelText}>
              {i18n.t('scanPack.onDemandCancel')}
            </Text>
          </TouchableOpacity>
        )}
      </LinearGradient>
    </View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
    justifyContent: 'center',
    alignItems: 'center'
  },
  card: {
    borderRadius: 12,
    paddingVertical: 26,
    paddingHorizontal: 20,
    alignItems: 'center'
  },
  message: {
    color: '#ffffff',
    fontSize: 18,
    textAlign: 'center',
    fontFamily: fontFamily.font500,
    marginBottom: 18
  },
  circle: {
    height: 104,
    width: 104,
    borderRadius: 52,
    borderWidth: 4,
    borderColor: '#ffffff',
    justifyContent: 'center',
    alignItems: 'center'
  },
  seconds: {
    color: '#ffffff',
    fontSize: 52,
    fontFamily: fontFamily.font700
  },
  cancelButton: {
    marginTop: 18
  },
  cancelText: {
    color: '#ffffff',
    fontSize: 14,
    textDecorationLine: 'underline',
    fontFamily: fontFamily.font400
  }
});

export default OnDemandCountdown;
